import * as React from 'react'
import { locales } from './locales'
import {StorageKey} from './storage'

export function isAuthenticated() {
    if (localStorage.getItem(StorageKey.Authenticated) === 'true') {
        return true
    }
    return false
}

export function isEnter(e) {
    if (e.key == 'Enter') {
        return true
    }
    return false
}

const menuDisabledPageList = [
    '/white_papers/ghost_completes_mr_05_2020/'
]

export function isSimplePage(path) {
    return path != '/' && menuDisabledPageList.some(url => url.includes(path))
}

export function spanReplacer(text: string, html: (text: string) => string) {
    if (text) {
        /* alternate \/[*].*\*[\/] */
        const result = text.replace(/\/\*[^*]*\*\//g, html)
        return <span dangerouslySetInnerHTML={{__html: result}} />
    } else {
        return <span />
    }
}

export function linkReplacer(text: string, html: (text: string) => string) {
    if (text) {
        const result = text.replace(/\/#[^#]*#\//g, html)
        return <span dangerouslySetInnerHTML={{__html: result}} />
    } else {
        return <span />
    }
}

export function tagger(text: string, className: string, defaultLink?: string, newTab?: boolean) {
    let resultText = text
    const textHtml = s => '<span class=\"' + className + '\">' + s.substring(2, s.length - 2) + '</span>'
    resultText = resultText.replace(/\/\*[^*]*\*\//g, textHtml)

    const linkHtml = s => {
        // link format can be text#=url
        let innerText: string = s.substring(2, s.length - 2)
        let link = defaultLink
        if (innerText.split('#=').length == 2 && !defaultLink) {
            [innerText, link] = innerText.split('#=')
        }
        return '<a href=\"' + (link ? link : innerText) + '\" class=\"' + className + '\"' + (newTab ? 'target=\"_blank\" rel=\"noopener noreferrer\"' : '') + '>' + innerText + '</a>'
    }
    resultText = resultText.replace(/\/#.*?#\//g, linkHtml)

    return resultText ? <span dangerouslySetInnerHTML={{__html: resultText}} /> : <span />
}

export function spanirizerByString(text: string, searchString: string, className: string) {
    const html = s => '<span class=\"' + className + '\">' + s + '</span>'
    const result = text.replace(new RegExp(searchString, 'g'), html)
    return <span dangerouslySetInnerHTML={{__html: result}} />
}

export const SITE_NAME = 'persona'
export const UNKNOWN_SERVER_ERROR = [{'unknown': 'server error'}]

export const ACCENT_TEXT = 'accent-text'
export const ACCENT_TEXT_FW500 = 'accent-text fw500'
export const ACCENT_TEXT_FW700 = 'accent-text fw700'
export const ACCENT_TEXT_FW700_M500 = 'accent-text fw700m500'
export const ACCENT_TEXT_FW700_T500 = 'accent-text fw700t500'

export const AQUA_TEXT = 'aqua-text'
export const AQUA_TEXT_FW500 = 'aqua-text fw500'

export const TOPBAR_COLOR_RED = {buttonColor: 'button-outline animated red', hoverColor: 'red-c', linkColor: 'red-l'}
export const TOPBAR_COLOR_ACCENT = {buttonColor: 'button-outline animated accent', hoverColor: 'accent-c', linkColor: 'accent-l'}
export const TOPBAR_COLOR_AQUA = {buttonColor: 'button-outline animated aqua', hoverColor: 'aqua-c', linkColor: 'aqua-l'}

export function errorSwitcher(errors) {
    const name = []
    const skype = []
    const company = []
    const email = []
    const pass = []
    const other = []
    const appSearchQuery = []
    errors.forEach(err => {
        const key = Object.keys(err)[0]
        switch (key) {
            case 'email':
                email.push(err[key] as never)
                break
            case 'password':
                pass.push(err[key] as never)
                break
            case 'companyName':
                company.push(err[key] as never)
                break
            case 'name':
                name.push(err[key] as never)
                break
            case 'skype':
                skype.push(err[key] as never)
                break
            case 'appSearchQuery':
                appSearchQuery.push(err[key] as never)
                break
            default:
                other.push(err[key] as never)
        }
    })
    return {name, skype, company, email, pass, other, appSearchQuery}
}

export function goToElementId(elementId, smooth: boolean) {
    const targetElement = document.getElementById(elementId)
    if (targetElement) {
        targetElement.scrollIntoView(smooth ? {behavior: 'smooth'} : undefined)
    }
}

export function goToHash(props) {
    const hash = props.location.hash.substring(1)
    if (hash) {
        goToElementId(hash, false)
    }
}

export function getSignUpPath(pathname) {
    switch (pathname) {
        case '/rtb':
            return 'contact'
        case '/market-research':
            return 'mrcontact'
        default:
            return 'sign_up'
    }
}

export function getFont(i18n) {
    switch (i18n.language) {
        case locales.ru:
        case locales.ruRU:
            return {fontFamily: 'Ubuntu, sans-serif'}
        case locales.ja:
        case locales.jaJP:
            return {fontFamily: 'Noto Sans JP, sans-serif'}
        case locales.ko:
        case locales.koKR:
            return {fontFamily: 'Noto Sans KR, sans-serif'}
        case locales.zh:
        case locales.zhCN:
            return {fontFamily: 'Noto Sans SC, sans-serif'}
        case locales.id:
        case locales.idID:
            return {fontFamily: 'Maven Pro, sans-serif'}
        case locales.en:
        case locales.enUS:
        default:
            return {fontFamily: 'Maven Pro, sans-serif'}
    }
}

export function setFont(font) {
    const tElements = document.getElementsByClassName('muli')
    const titles = Array.from(tElements)
    titles.forEach((t: HTMLImageElement) => t.style.fontFamily = font)
}

export function updateMuliFont(lang) {
    setFont(lang.includes(locales.en) ? 'Muli, sans-serif' : '')
}

export function setTitleFont(lang) {
    if (lang.includes(locales.en)) {
        setFont('Muli, sans-serif')
    }
}

const en = {flag: 'https://static.persona.ly/images/usa.svg', apiLang: 'en'}
const cn = {flag: 'https://static.persona.ly/images/china.svg', apiLang: 'cn'}
const jp = {flag: 'https://static.persona.ly/images/japan.svg', apiLang: 'jp'}
const kr = {flag: 'https://static.persona.ly/images/korea.svg', apiLang: 'kr'}
const ru = {flag: 'https://static.persona.ly/images/russia.svg', apiLang: 'ru'}
const id = {flag: 'https://static.persona.ly/images/indonesia.svg', apiLang: 'id'}

export const localeToInternalLang = new Map([
    [locales.en, en],
    [locales.enUS, en],
    [locales.zh, cn],
    [locales.zhCN, cn],
    [locales.ja, jp],
    [locales.jaJP, jp],
    [locales.ko, kr],
    [locales.koKR, kr],
    [locales.ru, ru],
    [locales.ruRU, ru],
    [locales.id, id],
    [locales.idID, id]
])


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/util.tsx